import { formatDate } from '@avanta/shared/utils/date';
import { Apple, Brain, BriefcaseBusiness, Heart, type LucideIcon, Users } from 'lucide-react';
import { type Tag } from 'types/wellbeing';

export const createTagMap = (tags: Tag[]): Map<string, Tag> =>
  new Map(tags.map(tag => [tag.id, tag]));

export const tagColorVar = (colorText?: string): string =>
  colorText ? `var(--color-${colorText})` : 'var(--color-gray-800)';

export const getMonthFromDate = (dateStr: string): string => {
  if (!dateStr) return '';
  try {
    return formatDate(dateStr, 'MMMM', 'dd/MM/yyyy');
  } catch {
    return '';
  }
};

const CATEGORY_ICONS: Partial<Record<string, LucideIcon>> = {
  habitos: Apple,
  'habitos-de-salud': Apple,
  competencias: Users,
  'salud-mental': Brain,
  'salud-emocional': Heart,
  'salud-relacional': Users,
  'realizacion-profesional': BriefcaseBusiness,
};

export const getTagCategoryIcon = (tagId: string): LucideIcon => CATEGORY_ICONS[tagId] ?? Heart;
